<div style="width: 70%; margin-left: 15%; margin-top: 3vw ">
  <h1>Buscador de Vuelos Genérico</h1>
<app-search-flight></app-search-flight>
</div>
